module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABDUlEQVRIS8XXoU6DMRSG4fdLMHAhIFAINBhgCwmGIEEjuB0cDhThAmAToDcEBsOVkEBySJPJ/Tvtekqrmz7taXryVXQa6uTiwma2DdwAG8CtpM+Iza6EzWwXmAFbC+wXOJU0qcU9+Ak4X4KMJT3X4B78BhwMAFW4B6eSHq042dq4B78Ax05J18Ij4LSvYjwKLsYj4SI8Gs7GW8AJP/GaTCs44XuSPoZeREv4XtJVD/hB0mUPeF/S+3/DI0mp6w2OFnec1cWi4Sw0lSESzkYj4SI0Ci5Gc+BuQeAVOOwRfR6Bix5hL8XbObC5wL+BM0nTmoTp3nGaYGY7wDXwA9xJ+qpFs+AIZNka7hemFfwHuoOFH8dUqkEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ibofang.png
// module id = nIwM
// module chunks = 0